/* Listendarstellung ohne Antd-Tabelle (SettingsListRows). Produkte setzen die Variablen --slr-*;
   ohne sie gelten die aus dem Antd-Theme abgeleiteten --slr-d-* (setzt SettingsListPage am Element). */

.slr, .slr-foot {
  /* Maße der Darstellung (benannt, damit Produkte sie gezielt überschreiben können) */
  --slr-n-0_45: 0.45;
  --slr-n-0_68rem: 0.68rem;
  --slr-n-0_75: 0.75;
  --slr-n-0_85rem: 0.85rem;
  --slr-n-1: 1;
  --slr-n-1_25: 1.25;
  --slr-n-10px: 10px;
  --slr-n-12px: 12px;
  --slr-n-14px: 14px;
  --slr-n-16px: 16px;
  --slr-n-18px: 18px;
  --slr-n-1px: 1px;
  --slr-n-1rem: 1rem;
  --slr-n-2: 2;
  --slr-n-3px: 3px;
  --slr-n-4px: 4px;
  --slr-n-44px: 44px;
  --slr-n-6px: 6px;
  --slr-n-84px: 84px;
  --slr-n-8px: 8px;
  --slr-c-surface: var(--slr-surface, var(--slr-d-surface));
  --slr-c-surface-hover: var(--slr-surface-hover, var(--slr-d-surface-hover));
  --slr-c-line: var(--slr-line, var(--slr-d-line));
  --slr-c-line-hover: var(--slr-line-hover, var(--slr-d-line-hover));
  --slr-c-text: var(--slr-text, var(--slr-d-text));
  --slr-c-text-2: var(--slr-text-2, var(--slr-d-text-2));
  --slr-c-text-3: var(--slr-text-3, var(--slr-d-text-3));
  --slr-c-accent: var(--slr-accent, var(--slr-d-accent));
  --slr-c-accent-soft: var(--slr-accent-soft, var(--slr-d-accent-soft));
  --slr-c-radius: var(--slr-radius, var(--slr-d-radius));
  --slr-c-row-gap: var(--slr-row-gap, 6px);
  --slr-c-cell-pad-y: var(--slr-cell-pad-y, 12px);
  --slr-c-cell-pad-x: var(--slr-cell-pad-x, 12px);
}

.slr {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  color: var(--slr-c-text);
  /* Nie seitlich scrollen: Überbreite schaltet SettingsListPage auf gestapelte Karten um. */
  overflow-x: clip;
}
.slr.is-loading .slr-grid { opacity: 0.55; pointer-events: none; }
.slr-loading-indicator { position: absolute; inset: 0; display: grid; place-items: center; pointer-events: none; }

/* ---------- Gemeinsames Raster: Kopf und Zeilen als Unterraster derselben Spalten ---------- */
.slr--grid .slr-grid { display: grid; row-gap: var(--slr-c-row-gap); min-width: 0; }
.slr--grid .slr-body { display: contents; }
.slr--grid .slr-head, .slr--grid .slr-row { grid-column: 1 / -1; grid-template-columns: subgrid; }
.slr--grid .slr-expanded, .slr--grid .slr-empty, .slr--grid .slr-loading-placeholder { grid-column: 1 / -1; }
.slr--stacked .slr-grid { display: flex; flex-direction: column; }

/* ---------- Kopfzeile ---------- */
.slr-head {
  display: grid;
  align-items: end;
  padding: 0 var(--slr-n-1px) var(--slr-n-6px);
  color: var(--slr-c-text-3);
  font-size: var(--slr-head-font-size, 0.7rem);
  font-weight: var(--slr-head-font-weight, 650);
  letter-spacing: var(--slr-head-tracking, 0.08em);
  text-transform: var(--slr-head-transform, uppercase);
}
.slr-head-cell {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 var(--slr-c-cell-pad-x);
  overflow: hidden;
  /* Spaltentitel stehen immer einzeilig; ihre Breite ist die Untergrenze der Spalte (SettingsListRows). */
  white-space: nowrap;
  line-height: var(--slr-n-1_25);
}
.slr-head-cell > :not(.slr-sort) { min-width: 0; }
.slr-sort {
  display: inline-flex;
  align-items: center;
  gap: var(--slr-n-6px);
  min-width: 0;
  max-width: 100%;
  margin: 0 calc(var(--slr-n-4px) * -1);
  padding: var(--slr-n-4px);
  border: 0;
  border-radius: var(--slr-n-4px);
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}
.slr-sort:hover, .slr-sort.is-active { color: var(--slr-c-text); }
.slr-sort:focus-visible { outline: 2px solid var(--slr-c-accent); outline-offset: 1px; }
/* Auslassungspunkte greifen nur im letzten Ausweg (Titel passen nicht, keine Karten); voller Name als Tooltip. */
.slr-sort-label { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; text-align: start; }
.slr--squeezed .slr-head-cell:not(:has(.slr-sort)) { text-overflow: ellipsis; }
.slr-sort-icon { display: inline-flex; flex-direction: column; font-size: var(--slr-n-8px); line-height: var(--slr-n-0_75); opacity: var(--slr-n-0_45); }
.slr-sort-icon .is-on { color: var(--slr-c-accent); opacity: 1; }
.slr-sort:hover .slr-sort-icon, .slr-sort.is-active .slr-sort-icon { opacity: 1; }

/* ---------- Zeilen ---------- */
.slr-body { display: flex; flex-direction: column; gap: var(--slr-c-row-gap); }
.slr-row {
  position: relative;
  display: grid;
  align-items: center;
  min-height: 52px;
  border: 1px solid var(--slr-c-line);
  border-radius: var(--slr-c-radius);
  background: var(--slr-c-surface);
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.slr-row.is-clickable { cursor: pointer; }
.slr-row:hover { border-color: var(--slr-c-line-hover); background: var(--slr-c-surface-hover); }
.slr-row.is-selected, .slr-row.settings-list-row-active, .slr-row.is-active { border-color: var(--slr-c-accent); background: var(--slr-c-accent-soft); }
.slr-row.settings-list-row-active, .slr-row.is-active { box-shadow: inset 4px 0 0 var(--slr-c-accent); }
.slr-row.is-expanded { border-bottom-left-radius: 0; border-bottom-right-radius: 0; }
.slr-row--child { margin-inline-start: var(--slr-n-18px); border-style: dashed; }
/* Summenzeile: wie eine Zeile, aber ohne Hover und mit kräftigeren Werten. */
.slr-row--summary,
.slr-row--summary:hover { border-color: var(--slr-c-line); background: var(--slr-c-surface-hover); font-weight: 600; }
.slr-cell {
  display: flex;
  align-items: center;
  gap: var(--slr-n-8px);
  min-width: 0;
  padding: var(--slr-c-cell-pad-y) var(--slr-c-cell-pad-x);
  overflow-wrap: anywhere;
  /* Lange Wörter („Investitionsverbindlichkeiten“) trennen an Silbengrenzen statt mitten im Wort. */
  hyphens: auto;
}
.slr-cell-value { min-width: 0; flex: 1 1 auto; }
.slr-cell--ellipsis .slr-cell-value { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.slr-cell--primary { font-weight: var(--slr-primary-weight, 600); }
.slr-cell--end { justify-content: flex-end; text-align: right; }
.slr-cell--end .slr-cell-value { flex: 0 1 auto; }
.slr-cell--center { justify-content: center; text-align: center; }
.slr-cell--select { justify-content: center; padding-inline: 0; }
/* Ziehgriff der Zeilensortierung: eigenes Bedienelement, 44 px Zielfläche */
.slr-cell--handle { justify-content: center; padding-inline: 0; }
.slr-row-handle {
  display: inline-grid;
  place-items: center;
  min-width: var(--slr-n-44px);
  min-height: var(--slr-n-44px);
  padding: 0;
  border: 0;
  border-radius: var(--slr-n-4px);
  background: none;
  color: var(--slr-c-text-2);
  cursor: grab;
  touch-action: none;
}
.slr-row-handle:active { cursor: grabbing; }
.slr-row-handle:disabled { cursor: default; opacity: 0.4; }
.slr-row.is-dragging { position: relative; z-index: 2; opacity: 0.72; }
.slr-cell--actions { justify-content: flex-end; overflow: visible; padding-block: var(--slr-n-6px); }
.slr-head .slr-cell--actions { justify-content: flex-end; }
.slr-cell--actions .slr-cell-value { flex: 0 0 auto; display: flex; justify-content: flex-end; }
/* Messfläche der Aktionen (beide Darstellungen): nimmt keinen Platz ein, Zellen in natürlicher Breite. */
.slr-probe {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  pointer-events: none;
}
.slr-probe > .slr-cell { flex: none; width: max-content; }
.slr-tree { display: inline-flex; flex: none; padding-inline-start: calc(var(--slr-depth, 0) * var(--slr-n-18px)); }
.slr-tree-toggle, .slr-tree-spacer { display: inline-grid; place-items: center; width: 22px; height: 22px; }
.slr-tree-toggle {
  padding: 0;
  border: 1px solid var(--slr-c-line);
  border-radius: var(--slr-n-4px);
  background: none;
  color: var(--slr-c-text-2);
  font-size: var(--slr-n-10px);
  cursor: pointer;
  transition: transform 160ms ease;
}
.slr-tree-toggle:not(.is-open) { transform: rotate(-90deg); }
.slr-expanded {
  margin-top: calc(var(--slr-c-row-gap) * -1);
  padding: var(--slr-n-12px) var(--slr-c-cell-pad-x);
  border: 1px solid var(--slr-c-line);
  border-top: 0;
  border-radius: 0 0 var(--slr-c-radius) var(--slr-c-radius);
  background: var(--slr-c-surface);
}
.slr-empty {
  display: grid;
  place-items: center;
  min-height: 120px;
  border: 1px dashed var(--slr-c-line);
  border-radius: var(--slr-c-radius);
  color: var(--slr-c-text-3);
}
.slr-loading-placeholder { min-height: 120px; }

/* ---------- Fuß: Summe und Seitenwechsel ---------- */
.slr-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--slr-n-8px) var(--slr-n-16px);
  margin-top: var(--slr-n-14px);
}
.slr-foot-summary { min-width: 0; color: var(--slr-c-text-2); font-size: var(--slr-n-0_85rem); }
.slr-pager { display: flex; flex-wrap: wrap; align-items: center; gap: var(--slr-n-4px); margin-inline-start: auto; }
.slr-pager-page, .slr-pager-step {
  display: inline-grid;
  place-items: center;
  min-width: 32px;
  height: 32px;
  padding: 0 var(--slr-n-8px);
  border: 1px solid transparent;
  border-radius: var(--slr-c-radius);
  background: none;
  color: var(--slr-c-text-2);
  font: inherit;
  font-size: var(--slr-n-0_85rem);
  font-variant-numeric: tabular-nums;
  cursor: pointer;
}
.slr-pager-page:hover, .slr-pager-step:hover:not(:disabled) { border-color: var(--slr-c-line); color: var(--slr-c-text); }
.slr-pager-page.is-current { border-color: var(--slr-c-accent); background: var(--slr-c-accent-soft); color: var(--slr-c-text); font-weight: 650; }
.slr-pager-step:disabled { opacity: 0.35; cursor: default; }
.slr-pager-gap { padding: 0 var(--slr-n-4px); color: var(--slr-c-text-3); }
.slr-pager-size select {
  height: 32px;
  margin-inline-start: var(--slr-n-8px);
  padding: 0 var(--slr-n-8px);
  border: 1px solid var(--slr-c-line);
  border-radius: var(--slr-c-radius);
  background: var(--slr-c-surface);
  color: var(--slr-c-text);
  font: inherit;
  font-size: var(--slr-n-0_85rem);
}

/* ---------- Gestapelte Karten (schmal oder Überbreite) ---------- */
.slr-stacked-head { display: flex; align-items: center; justify-content: space-between; gap: var(--slr-n-8px); margin-bottom: var(--slr-n-8px); }
.slr--stacked .slr-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 0;
  padding: var(--slr-n-10px) var(--slr-n-4px) var(--slr-n-8px);
}
.slr--stacked .slr-cell { padding: var(--slr-n-3px) var(--slr-n-10px); }
.slr--stacked .slr-cell--select { grid-column: var(--slr-n-2); grid-row: var(--slr-n-1); justify-content: flex-end; padding-inline: var(--slr-n-10px); }
.slr--stacked .slr-cell--primary { grid-column: var(--slr-n-1); grid-row: var(--slr-n-1); font-size: var(--slr-n-1rem); }
.slr--stacked .slr-cell--handle { grid-column: var(--slr-n-2); grid-row: var(--slr-n-1); justify-content: flex-end; padding-inline: var(--slr-n-4px); }
.slr--stacked .slr-row:not(:has(.slr-cell--select, .slr-cell--handle)) .slr-cell--primary { grid-column: 1 / -1; }
/* Bildspalte neben dem Kartentitel */
.slr--stacked .slr-row:has(> .slr-cell--media) { grid-template-columns: auto minmax(0, 1fr) auto; }
.slr--stacked .slr-row:has(> .slr-cell--media) > .slr-cell--media { grid-column: 1; grid-row: 1; padding-inline-end: 0; }
.slr--stacked .slr-row:has(> .slr-cell--media) > .slr-cell--primary { grid-column: 2 / -1; grid-row: 1; align-self: center; }
.slr--stacked .slr-row:has(> .slr-cell--media):has(> .slr-cell--select) > .slr-cell--primary { grid-column: 2; }
.slr--stacked .slr-row:has(> .slr-cell--media) > .slr-cell--select { grid-column: 3; }
/* Leere Felder entfallen in der Karte */
.slr--stacked .slr-cell:not(.slr-cell--primary, .slr-cell--select, .slr-cell--handle):has(> .slr-cell-value:empty) { display: none; }
.slr--stacked .slr-cell:not(.slr-cell--primary, .slr-cell--select, .slr-cell--handle, .slr-cell--actions, .slr-cell--media) {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: minmax(96px, 38%) minmax(0, 1fr);
  align-items: baseline;
  gap: var(--slr-n-10px);
}
.slr--stacked .slr-cell[data-label]::before {
  content: attr(data-label);
  color: var(--slr-c-text-3);
  font-size: var(--slr-n-0_68rem);
  font-weight: 650;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.slr--stacked .slr-cell:not([data-label]):not(.slr-cell--primary, .slr-cell--select, .slr-cell--actions, .slr-cell--media) { grid-template-columns: minmax(0, 1fr); }
.slr--stacked .slr-cell--ellipsis .slr-cell-value { white-space: normal; }
.slr--stacked .slr-cell--end, .slr--stacked .slr-cell--center { justify-content: flex-start; text-align: left; }
.slr--stacked .slr-cell--actions {
  grid-column: 1 / -1;
  justify-content: flex-start;
  margin-top: var(--slr-n-6px);
  padding-top: var(--slr-n-8px);
  border-top: 1px solid var(--slr-c-line);
}
.slr--stacked .slr-cell--actions .slr-cell-value { justify-content: flex-start; flex-wrap: wrap; }
.slr--stacked .slr-cell--actions:has(.slr-cell-value:empty) { display: none; }
.slr--stacked .slr-row--child { margin-inline-start: var(--slr-n-12px); }
@media (max-width: 575.98px) {
  .slr--stacked .slr-cell:not(.slr-cell--primary, .slr-cell--select, .slr-cell--actions, .slr-cell--media) { grid-template-columns: minmax(var(--slr-n-84px), 40%) minmax(0, 1fr); gap: var(--slr-n-8px); }
  .slr-pager { margin-inline-start: 0; }
  .slr-pager-size select { margin-inline-start: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .slr-row, .slr-tree-toggle { transition: none; }
}

/* ---------- Eingebettete Detailzeilen (aufgeklappte Gruppe) ---------- */
.slr--nested { --slr-row-gap: var(--slr-n-4px); }
.slr--nested .slr-head { padding-bottom: var(--slr-n-4px); }
.slr--nested .slr-row { min-height: 0; box-shadow: none; }
.slr--nested .slr-row:hover { transform: none; }
.slr--nested .slr-cell { padding-block: var(--slr-n-6px); }

/* DataList (shared/frontend/list/DataList): Bedienelemente über der Liste. */
.data-list-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--mq-space-xs);
  margin-bottom: var(--mq-space-sm);
}
